// One dataLayer event per successful HubSpot submission, for GTM to count leads on.
// GA4's automatic form_submit fires on submit attempts and once per Google tag, so it
// over-counts; this only reacts to HubSpot confirming the submission.
type Layer = Window & { dataLayer?: Record<string, unknown>[] };

const sent = new Map<string, number>();

function push(formId: string, instance: string): void {
	const key = `${formId}|${instance}`;
	const now = Date.now();

	// Both HubSpot channels can report the same submission; count it once.
	if (now - (sent.get(key) ?? 0) < 5000) {
		return;
	}

	sent.set(key, now);

	const layer = ((window as Layer).dataLayer = (window as Layer).dataLayer ?? []);

	layer.push({
		event: 'hubspot_form_success',
		hubspot_form_id: formId,
		hubspot_form_instance: instance,
	});
}

export default function initHubspotAnalytics(): void {
	// Developer embed (hsfc), used by our blocks.
	window.addEventListener('hs-form-event:on-submission:success', (event) => {
		const detail = ((event as CustomEvent).detail ?? {}) as { formId?: string; instanceId?: string };

		push(detail.formId ?? '', detail.instanceId ?? '');
	});

	// Classic embed, still on the older pages.
	window.addEventListener('message', (event) => {
		const data = event.data as { type?: string; eventName?: string; id?: string } | null;

		if (data?.type === 'hsFormCallback' && data.eventName === 'onFormSubmitted') {
			push(data.id ?? '', '');
		}
	});
}
